import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import LatestUpdates from "./latestupdates";
import { motion } from "framer-motion";
import "./img.css";
import { Container, Row, Col, Card, ListGroup, Button, Image, Table } from "react-bootstrap";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import Footer from './footer';



const ContentSection = () => (
    <>
        <div className="container">
            <h2 className="fw-bold ">Skill Assessment</h2>
            <p className="mt-3">
                Skill assessment is the backbone of any skilled migration and employer
                sponsored visa. Obtaining suitable skills assessment is mandatory for many
                visa subclasses, and we can help you to get your skills assessed in your relevant
                field or occupation, be it ACS,CPA\IPA, TRA, VETASSESS, ANMAC/AHPRA, ACWA, Engineers Australia etc.
            </p>

        </div>
    </>
);

const Sidebar = () => (
   
  <Col md={12}>
    <div style={{ maxWidth: "800px", width: "100%" }}>
        <Card className="border-0 shadow-none">
        <Card.Header >Latest Posts</Card.Header>
            <ListGroup variant="flush">
                <ListGroup.Item className="border-0"><Link to="/professional" className="dropdown-item"> <a href="" className="text-decoration-none">Professional Year</a> </Link></ListGroup.Item>
                <ListGroup.Item className="border-0"><Link to="/coursechange" className="dropdown-item"> <a href="" className="text-decoration-none">Admissions And Course Change </a></Link></ListGroup.Item>
                <ListGroup.Item className="border-0"><Link to="/skilledID" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Independent Visa (Subclass 189)</a></Link></ListGroup.Item>
                <ListGroup.Item className="border-0"><Link to="/workregionalvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Work Regional Visa (Subclass 491)</a></Link></ListGroup.Item>
                <ListGroup.Item className="border-0"><Link to="/nominatedvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Nominated Visa (Subclass 190)</a></Link></ListGroup.Item>
                <ListGroup.Item><a href="https://immi.homeaffairs.gov.au/visas/getting-a-visa/visa-listing/skilled-regional-191"
                                                    className="dropdown-item text-decoration-none "
                                                    style={{ color: "#22327f" }}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                  >
                                                    Permanent Residence visa (Subclass 191)
                                                  </a>
                                                </ListGroup.Item>
                                {/* <ListGroup.Item><Link to="/regionalvisa" className="dropdown-item"><a href="" className="text-decoration-none">Skilled Regional Visa (Subclass 887)</a></Link></ListGroup.Item> */
                                <ListGroup.Item><Link to="/tempactivity" className="dropdown-item"><a href="" className="text-decoration-none">Temporary Activity Visa (Subclass 408)</a></Link></ListGroup.Item>
}
                            </ListGroup>
        </Card>
    </div>
</Col>

);

const VisaPage = () => {

    return (
        <div className="container mt-4">
            {/* Apply Section */}
            <div className="row">
                {/* Left Content */}
                <div className="col-md-8">
                    <p>Skills assessments arestandardly issued by relevant skills assessing authorities that checks that
                        your skills meet the standards they set to work in a relevant occupation. The combined list of
                        eligible skilled occupations sets out all relevant occupations under the 4 occupation lists.</p>
                    <p className="fw-bold ">You can Check that which Authority provide Skill Assessment for you profession by<a href="https://immi.homeaffairs.gov.au/visas/working-in-australia/skill-occupation-list"> clicking here.</a></p>
                    <h3 className="fw-bold text-decoration-underline ">– SKILLS ASSESSMENT FOR TRADE OCCUPATIONS</h3>
                    <p className="mt-3">
                        If you have completed your trade qualification and want to have your skills assessed these are the steps you need to follow:</p>
                    <h4 className="fw-bold"> STEP 1 –PROVISIONAL SKILLS ASSESSMENT</h4>
                    <p className="mt-3"> Under PSA, TRA will confirm your identity and verify the authenticity of your Australian qualification,
                        and that you are doing a range of tasks and duties relevant to your nominated occupation in an Australian workplace.
                        A successful PSA outcome can be used to apply to Home Affairs for a Temporary Graduate visa (subclass 485). A successful
                        PSA outcome is required before you can apply for Step 2 JRE of the JRP.  </p>
                    <h4>ELIGIBILITY:</h4>
                    <p>To be eligible for a PSA you must have:</p>
                    <ul>
                        <li>held an international student visa (as the primary visa holder) to study in Australia</li>
                        <li>a qualification relevant to an occupation assessed by TRA, and awarded by a CRICOS RTO as a result of study in Australia</li>
                        <li>evidence of a minimum of 360 hours of employment and/or a vocational placement relevant to your qualification and nominated occupation,
                            completed in an Australian workplace, within the three years prior to submitting a PSA application</li>
                    </ul>
                    <p className="mt-3">Documents needed to assess Provisional Skill Assessment/360 Hours:</p>
                    <ul>
                        <li>Passport (all pages)</li>
                        <li>One Passport Size Photograph</li>
                        <li>Australian Qualification</li>
                        <li>Evidence of 360 hours of employment and/or Vocational Placement relevant to your qualification-</li>
                        <VisaTable />
                        <li>Business advertisement of the employer on the local website i.e. True local, White pages or Yellow pages.</li>
                    </ul>
                    <h4>ASSESSMENT OUTCOME:</h4>
                    <p className="mt-3">You will receive notification of the outcome of your PSA application by email following the assessment and verification process. If your assessment is successful, the outcome letter can be presented to Home Affairs as pAAT of your 485 visa application.</p>
                    <p className="mt-3"><b>Important Note:</b> Once you got your Successful PSA Outcome and you are on 485 Visa or lodged visa application/holding Bridging Visa (with full rights) please register yourself as soon as possible for (Step-2) Job Ready Employment through Online Portal.</p>
                    <h4 className="fw-bold">STEP 2 – JOB READY EMPLOYMENT</h4>
                    <p className="mt-3">For Job Ready Employment, applicants must find employment in their nominated occupation, and submit that employment for Job Ready Employment through the online portal and provide the appropriate registration documents to TRA.</p>
                    <h4>ELIGIBILITY:</h4>
                    <ul>
                        <li>have received a successful PSA outcome</li>
                        <li>have less than 4 months remaining on your student visa</li>
                        <li>hold or have lodged an application with Home Affairs for a visa that has full (unrestricted) work rights and provides sufficient time to complete Steps 2‐4 of the JRP (a minimum of 12 months)</li>
                        <li>have secured eligible employment</li>
                    </ul>
                    <h4>EMPLOYMENT REQUIREMENTS:</h4>
                    <p className="mt-3">You must complete at least 1725 hours of paid employment in your nominated occupation over a minimum of 12 calendar months from your JRE StAAT Date. Periods of leave (including paid leave) cannot be included in the 1725 hours. Claiming prior employment: You can claim up to three consecutive months of paid employment that was undertaken immediately prior to applying online for JRE. This can only be claimed at the time of submitting your JRE application online.</p>
                    <p className="mt-3">Prior employment will only be considered where it was:</p>
                    <ul>
                        <li>undertaken with the first employer you registered for JRE</li>
                        <li>in your nominated occupation</li>
                        <li>undertaken in the three months immediately prior to your online JRE application</li>
                        <li>not already used to meet the work requirements for your PSA application</li>
                        <li>supported with acceptable pay evidence</li>
                        <li>for employment arrangements approved by TRA</li>
                    </ul>
                    <h4 className="fw-bold">STEP 3—JOB READY WORKPLACE ASSESSMENT</h4>
                    <p className="mt-3">When a pAATicipant has completed and provided acceptable evidence of at least 863 hours of paid employment over a minimum of six months, they may be eligible to pAATicipate in Step 3 – a Job Ready Workplace Assessment.</p>
                    <h4>EVIDENCE INCLUDES:</h4>
                    <ul>
                        <li>Skilled Progress Report</li>
                        <li>Payslips/Invoices with Bank Statement</li>
                    </ul>
                    <h4 className="fw-bold">STEP 4— JOB READY FINAL ASSESSMENT</h4>
                    <p className="mt-3">A Job Ready Final Assessment is conducted when acceptable evidence of at least 1725 hours of paid employment over a minimum of 12 calendar months is verified and after the successful completion of a Job Ready Workplace Assessment. For further information regarding PSA/Job Ready Program you can visit https://www.tradesrecognitionaustralia.gov.au </p>
                    <p className="mt-3"> Fees (Fees Is Subject To vary Please Check with TRA)</p>
                    <VisaTable1/><br/>
                

                </div>

                {/* Right Sidebar */}
                <div className="col-md-4 text-center">
                    <img src="./img/brand-logo.png" alt="Bajwa Immigration Consultants" className="img-fluid mb-3" />
                    <h5 className="fw-bold">Subscribe to our YouTube channel</h5>
                    <button className="btn btn-danger my-2"><a href="https://www.youtube.com/embed/uOGAB9oYets">SUBSCRIBE</a></button>
                    <br />
                    <button className="btn btn-warning fw-bold my-2">BOOK CONSULTATION</button>

                    {/* Social Media Icons */}
                    <div className="d-flex justify-content-center gap-2 mt-3">
                        <a href="#" className="text-primary fs-4"><i className="bi bi-facebook"></i></a>
                        <a href="#" className="text-dark fs-4"><i className="bi bi-tiktok"></i></a>
                        <a href="#" className="text-danger fs-4"><i className="bi bi-youtube"></i></a>
                        <a href="#" className="text-info fs-4"><i className="bi bi-instagram"></i></a>
                    </div>
                </div>
            </div>



            {/* Feedback Button */}
            <motion.button
    initial={{ x: "-100vw", opacity: 0 }}
    animate={{ x: 0, opacity: 1 }}
    transition={{ type: "tween", duration: 0.6, ease: "easeOut" }}
    className="btn btn-danger btn-sm position-fixed bottom-0 stAAT-0 m-3"
    style={{ zIndex: 1050 }}
>
    <i className="bi bi-chat-left-text me-1"></i>
    <a 
        href="https://au.bajwaimmigration.com/book-appointment" 
        className="text-white text-decoration-none"
    >
        Consult Now
    </a>
</motion.button>
        </div>
    );
};


const VisaTable = () => {
    return (
        <div className=" mt-4 table-responsive">
            <Table bordered hover className="table">
                <thead className="table-light">
                </thead>
                <tbody>
                    <tr>
                        <td>
                            Paid Employment               </td>
                        <td>Experience letter from Employer and Payslips

                        </td>
                    </tr>

                    <tr>
                        <td>
                            Vocational Placement
                        </td>
                        <td>
                            Placement letter from college, Experience letter from Employer, one copy of log book(attested)
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Working on ABN
                        </td>
                        <td>
                            Working on ABN</td>
                    </tr>

                </tbody>
            </Table>
        </div>
    );
};

const VisaTable1 = () => {
    return (
        <div className="mt-4 table-responsive">
            <Table bordered hover className="table">
                <thead className="table">
                </thead>
                <tbody>
                    <tr>
                        <td>
                        <strong> 
Fee Type     </strong> 
     </td>
                        <td>  <strong> Fee</strong> 

                        </td>
                    </tr>

                    <tr>
                        <td>
                        Provisional Skills Assessment
                        </td>
                        <td>
                        $300
                        </td>
                    </tr>
                    <tr>
                        <td>
                        Provisional Skills Assessment Appeals (if required)
                        </td>
                        <td>
                        $300
                        </td>
                    </tr>
                    <tr>
                        <td>
                        Job Ready Employment
                        </td>
                        <td>
                        $500</td>
                    </tr>
                    <tr>
                        <td>
                        Job Ready Workplace Assessment
                        </td>
                        <td>
                        $2,000</td>
                    </tr>
                    <tr>
                        <td>Subsequent Job Ready Workplace Assessment (if required)</td>
                        <td>$2,000</td>
                    </tr>
                    <tr>
                        <td>Job Ready Final Assessment</td>
                        <td>$150</td>
                        </tr>
                </tbody>
            </Table>
        </div>
    );
};


const SkillVisas = () => (
    <>
        <div className="container mt-4">

            <div className="row mt-4">
                <div className="col-md-8">
                    <ContentSection />
                </div>
                <div className="col-md-4">
                    <Sidebar />
                </div>
            </div>
            <VisaPage />

        </div>
        <LatestUpdates />
        <Footer />
    </>
);

export default SkillVisas;